
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"23.51","height":"24.801"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"data-name":"Vereinigungsmenge 8","d":"M.65 24.15v-1.528c0-3.06 2.36-5.3 5.562-6.026 2.262-.512 3.245-1.293 3.245-2.318v-.681h0a6.826 6.826 0 01-3.245-5.809s-1.217-6.35 3.767-6.675c1.388-.09 3.2 1.2 4.77 1.2A3.53 3.53 0 0017.337.652v7.139a6.826 6.826 0 01-3.245 5.809v1.05h.007c.227.873 1.272 1.509 3.2 1.946a7.86 7.86 0 013.983 2.137 5.53 5.53 0 011.58 3.889v1.528z","fill":"none","stroke":"#fff","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.3"}})])
          )
        }
      }
    